//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Layout2d.js";
import "../no/Builder.js";
import "../Layout2d/Layout2d.ComponentNameBuilder.js";
import "../no/SelectNXObjectList.js";
import "../Gateway/Gateway.ImageCaptureBuilder.js";
import "../no/Gateway.js";
import "../no/ScCollector.js";
import "../no/SelectObjectList.js";
let d=[[[0,"ActiveSet",0,"ScCollector",0],[0,"ActiveSetScope",1,0],[0,"AnchorPoint",1,"Point",0],[1,"ComponentName",0,"Layout2d.ComponentNameBuilder",0],[1,"Contents",0,"SelectNXObjectList",0],[1,"ImageCapture",0,"Gateway.ImageCaptureBuilder",0],[0,"ImageName",1,0]],[[["object"],"IsValidActiveSetMember",{R_:{result:''}},1,0],[["path"],"SetPath",{},1,0],[["locationType"],"SetLocation",{},1,0]],[]];
SPLM.Layout2d.DefineComponentBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Layout2d.DefineComponentBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;